//TRIF CALCULATION

export function getMonthKey(year, monthIdx) {
  return `${year}-${String(monthIdx + 1).padStart(2, '0')}`;
}
export function parseKey(key) {
  const [y, m] = key.split('-').map(Number);
  return { year: y, monthIdx: m - 1 };
}
export function isFilled(v) {
  return (
    v !== undefined && v !== null && v !== '' && Number.isFinite(Number(v))
  );
}
export function toNum(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}
export function toIdx(key) {
  const { year, monthIdx } = parseKey(key);
  return year * 12 + monthIdx;
}
export function fromIdx(idx) {
  const y = Math.floor(idx / 12);
  const m = (idx % 12) + 1;
  return `${y}-${String(m).padStart(2, '0')}`;
}
export function monthLabel(key) {
  const { year, monthIdx } = parseKey(key);
  return `${new Date(year, monthIdx, 1).toLocaleString('default', {
    month: 'long',
  })} ${year}`;
}
export function rollingKeysForMonth(mk, monthsBack = 12) {
  const { year, monthIdx } = parseKey(mk);
  const keys = [];
  for (let i = monthsBack - 1; i >= 0; i--) {
    const d = new Date(year, monthIdx - i, 1);
    keys.push(getMonthKey(d.getFullYear(), d.getMonth()));
  }
  return keys;
}
export function cleanWorkingHours(obj) {
  const out = {};
  for (const [k, v] of Object.entries(obj || {})) {
    const entry = {};
    if (isFilled(v?.worked)) entry.worked = toNum(v.worked);
    if (isFilled(v?.lost)) entry.lost = toNum(v.lost);
    if (Object.keys(entry).length) out[k] = entry;
  }
  return out;
}
export function computeRollingAll(workingMap) {
  if (!workingMap) return {};
  const keys = Object.keys(workingMap);
  if (keys.length === 0) return {};

  const minIdx = Math.min(...keys.map(toIdx));
  const maxIdx = Math.max(...keys.map(toIdx));

  const filled = {};
  for (let i = minIdx; i <= maxIdx; i++) {
    const k = fromIdx(i);
    const base = workingMap[k] || {};
    filled[k] = {
      worked: toNum(base.worked),
      lost: toNum(base.lost),
    };
  }

  let sumWorked = 0;
  const window = [];
  const result = {};
  for (let i = minIdx; i <= maxIdx; i++) {
    const k = fromIdx(i);
    const w = filled[k].worked;
    sumWorked += w;
    window.push(w);
    if (window.length > 12) sumWorked -= window.shift();
    result[k] = {
      worked: filled[k].worked,
      lost: filled[k].lost,
      total: sumWorked,
    };
  }
  return result;
}
export function fmtRangeStart(idx) {
  const k = fromIdx(idx);
  const { year, monthIdx } = parseKey(k);
  return `${year}-${String(monthIdx + 1).padStart(2, '0')}-01 00:00:00`;
}
export function fmtRangeEnd(idx) {
  const k = fromIdx(idx);
  const { year, monthIdx } = parseKey(k);
  const lastDay = new Date(year, monthIdx + 1, 0).getDate();
  return `${year}-${String(monthIdx + 1).padStart(2, '0')}-${String(
    lastDay,
  ).padStart(2, '0')} 23:59:59`;
}
